import React from 'react';
import { YouTubeEmbed } from 'react-social-media-embed';
import PopUp from './PopUp';
import { useDispatch } from "react-redux";
import Img from "@assets/img";
import * as S from "./ReferFriendPopup/style";

interface HowItWorksProps {
  isOpen: boolean;
  toggle: () => void;
  videoUrl: string;
}

const HowItWorks: React.FC<HowItWorksProps> = ({ isOpen, toggle, videoUrl }) => {
  return (
    <PopUp visible={isOpen} title="How It Works" onCancel={toggle}>
      <S.ModalContent>
        {/* <div className="gap-3"> */}
        {/* <div>
                <S.ImgMascot src={Img.Mascot_1} />
              </div> */}
        {/* <div> */}
        <YouTubeEmbed url={videoUrl} width={460} height={360} />
        {/* </div> */}
        {/* </div> */}
      </S.ModalContent>
    </PopUp>
  );
};

export default HowItWorks;
